import { Route } from '@angular/router';
import { RoutingKeys } from '@core/routing/routing-keys';
import { LayoutComponent } from '@layout/layout.component';

export const appRoutes: Route[] = [
    // { path: '', pathMatch: 'full', redirectTo: 'example' },
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: RoutingKeys.PAYMENT_INTENT,
                loadChildren: () =>
                    import(
                        './modules/payment-intent/payment-intent.module'
                    ).then((m) => m.PaymentIntentModule),
            },
            {
                path: RoutingKeys.CONNECT,
                loadChildren: () =>
                    import('./modules/connect/connect.module').then(
                        (m) => m.ConnectModule
                    ),
            },
            {
                path: RoutingKeys.ITEM,
                loadChildren: () =>
                    import('./modules/item/item.module').then(
                        (m) => m.ItemModule
                    ),
            },
            {
                path: RoutingKeys.SHOP,
                loadChildren: () =>
                    import('./modules/shop/shop.module').then(
                        (m) => m.ShopModule
                    ),
            },
            {
                path: RoutingKeys.USER,
                loadChildren: () =>
                    import('./modules/user/user.module').then(
                        (m) => m.UserModule
                    ),
            },
            {
                path: RoutingKeys.NOT_FOUND,
                loadChildren: () =>
                    import('./modules/error/not-found/not-found.module').then(
                        (m) => m.NotFoundModule
                    ),
            },
        ],
    },
];
